// extracted by mini-css-extract-plugin
export default {"linkWrapper":"ProjectHeader_linkWrapper_AoHuM","link":"ProjectHeader_link_tMAGj","title":"ProjectHeader_title_PeXlw"};